import React from 'react';

import { tx } from './i18n';

export default function AuthFrame({ children }) {
  return (
    <main id="xo" className="xo-auth">
      <div className="xo-auth-shell">
        <aside className="xo-auth-brand" aria-hidden="true">
          <div className="xo-auth-hero">
            <h1>{tx('ui.shell.xomics_fc526e73')}</h1>
            <p>{tx('ui.shell.sign_in_to_continue_to_the_secure_omics_workspace_f884edfa')}</p>
          </div>
          <span className="xo-auth-security xo-auth-footer">
            {tx('ui.shell.authorised_personnel_only')}
          </span>
        </aside>
        <section className="xo-auth-card">
          <div className="xo-auth-card-inner">{children}</div>
        </section>
      </div>
    </main>
  );
}
